import React, { useEffect, useState, FC } from "react";
import { Button } from "antd";
import "../Dashboard/Dashboard.scss";
import { getFriendUserInfo } from "utils/chatUtils";

const CallNotification: FC<{
  page?: any;
  sender?: string;
  onAccept: (page: CallNotificationPageObj) => void;
  onDecline: () => void;
  allUsers?: any;
}> = ({
  page = { title: "NUMAN TEST" },
  sender = "1132",
  onAccept,
  onDecline,
  allUsers
}) => {
    const [audio, setAudio] = useState<HTMLAudioElement>();


    useEffect(() => {
      
      const sound = new Audio("/audio/ring-normal.wav");
      sound.loop = true;
      setAudio(sound);
      return () => {
        sound.pause();
      };
    }, []);

    useEffect(() => {
      if (audio) {
        audio.play();
        if (page.b2t) {
          setTimeout(() => {
            audio.pause();
          }, 2000)
        }
        setTimeout(() => {
          onDecline();
        }, 10000)
      }
    }, [audio]);


    return (
      <div className="video-invitation-wrapper">
        <div className="call-animation">
          <Button className="beam-btn accept-call" onClick={() => onAccept(page)}>
            <img className="action-icon" src="/images/call.png" />
          </Button>
          <div className="title">
            <h4>
              Video Call
              <br />
              <span>({page?.page?.persistent?.static?.metadata?.title ||
                (page?.page?.persistent?.static?.metadata?.type === "friend" &&
                getFriendUserInfo(allUsers,page?.page?.persistent?.static?.metadata?.members?.users)
                    ?.beamId
                  ? getFriendUserInfo(
                    allUsers,
                    page?.page?.persistent?.static?.metadata?.members?.users
                  )?.beamId
                  : `Page ${page?.page?.pageId}`)})</span>
            </h4>
          </div>
          <Button className="beam-btn deny-call" onClick={onDecline}>
            <img className="action-icon" src="/images/call.png" />
          </Button>
        </div>
      </div>
    );
  };

export default CallNotification;
